<template>
<div class="FansCommentMgt">
</div>
</template>

<script>
export default {
    name: 'FansCommentMgt',
    data() {
        return {}
    },
    mounted() {
    },
    methods: {},
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.FansCommentMgt {
}
</style>
